import React, { useState } from "react";
import CreatableSelect from "react-select/creatable";
import { customReactSelectStyles } from "./medication-select";
import { useEffect } from "react";
import { frequencyOptions } from "../../service-steps/clinical-assessment/data";

const FrequencySelect = ({
  onChange = () => {},
  isRequired = false,
  error = false,
  value: actualValue = { value: "", label: "" },
  selectedMedicine = {
    doseOptions: [],
    dose: null,
    formOptions: [],
    form: null,
    routeOptions: [],
    route: null,
    frequency: null,
  },
  isDisabled = false,
}) => {
  const [isLoading, setIsLoading] = useState(false);
  const [options, setOptions] = useState(frequencyOptions);
  const [value, setValue] = useState(null);
  const [showError, setShowError] = useState(false);

  useEffect(() => {
    const { frequency } = selectedMedicine;
    let defaultOptions = [];
     if (frequency) {
      defaultOptions = [
        { label: frequency, value: frequency  },
        ...frequencyOptions
      ];
      setValue(defaultOptions[0]);
      onChange(defaultOptions[0]);
      setOptions(defaultOptions);
    } 
    else {
      setOptions(frequencyOptions);
    }
    
  }, [selectedMedicine]);
  const handleCreate = (inputValue) => {
    setIsLoading(true);
    setTimeout(() => {
      const newOption = {
        label: inputValue,
        value: inputValue ,
      };
      setIsLoading(false);
      setOptions((prevOptions) => [...prevOptions, newOption]);
      setValue(newOption);
      setShowError(isRequired && !newOption);
      onChange(newOption);
    }, 300);
  };

  const handleBlur = () => {
    if (isRequired && !value) {
      setShowError(true);
    } else {
      setShowError(false);
    }
  };

  useEffect(() => {
    if (actualValue?.value) {
      setValue(actualValue);
    } else {
      setValue(null);
    }
  }, [actualValue]);

  useEffect(() => {
    if (error) {
      setShowError(true);
    } else {
      setShowError(false);
    }
  }, [error]);

  return (
    <div className="w-full col-span-8">
      <div
        className={`relative rounded-[4px] border-[1px] ${
          showError ? "border-red-200" : "border-gray-100"
        } ${isDisabled ? 'pointer-events-none opacity-70': ''} ${!isDisabled && isRequired && value === null ? "bg-blue-100" : "bg-white"} px-3 py-3 focus-within:border-REELTeal focus-within:border-[2px]`}
      >
        <div className="">
          <span className="block mb-1 text-gray-900 text-body-xs">
            Frequency {isRequired && <span className="">*</span>}
          </span>
          <CreatableSelect
            isClearable
            styles={customReactSelectStyles(isRequired, value)}
            isDisabled={isLoading || isDisabled}
            isLoading={isLoading}
            onChange={(newValue) => {
              setValue(newValue);
              setShowError(isRequired && !newValue);
              onChange(newValue);
            }}
            onCreateOption={handleCreate}
            onBlur={handleBlur}
            options={options}
            value={value}
            placeholder="Select frequency"
          />
        </div>
      </div>
      {showError && (
        <span className="block mt-1 text-red-200 text-body-xs ">
          This field is required
        </span>
      )}
    </div>
  );
};

export default FrequencySelect;
